module.exports = "<div class=\"row\">\r\n<div class=\"col-sm-12\">\r\n  <highcharts-chart [Highcharts]=\"RequiredReportsChart\" [options]=\"requiredReportchartOptions\"   [(update)]=\"updateFromInput\"></highcharts-chart>\r\n</div>\r\n<!-- <div class=\"col-sm-12\">\r\n  <highcharts-chart [Highcharts]=\"VoluntaryReportsChart\" [options]=\"voluntaryReportchartOptions\"></highcharts-chart>\r\n</div> -->\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/reports-dashboard/dashboard/reports-total-count-card/reports-total-count-card.component.html
// module id = ./src/app/admin/reports-dashboard/dashboard/reports-total-count-card/reports-total-count-card.component.html
// module chunks = main